import { GetStaticProps } from 'next';
import { useEffect } from 'react';
import { ClearInNavbar } from '../../../../components/Navbar/ClearNavbar';
import { ItrProductGuidePage } from '../../../../components/S/cleartax-itr-filing-guide';
import { META_DATA } from '../../../../components/S/cleartax-itr-filing-guide/constants';
import { defaultData } from '../../../../components/cms/layout/components/header';
import { BLOG_POST_SCHEMA } from '../../../../constants/componentStaticData';
import { Meta } from '../../../../layout/Meta';
import { FM_ACTIONS, returnNoProps } from '../../../../utils/UtilFunctions';
import { staticPropsWrapper } from '../../../../utils/static-pages/utils';
import { handleTrack } from '../../../../utils/tracker';

const ItrProductGuide = () => {
  useEffect(() => {
    if (window !== undefined) {
      handleTrack({
        label: window.location.pathname,
        action: FM_ACTIONS.pageview,
      });
    }
  });
  const { title, description, canonical, keywords } = META_DATA;

  return (
    <div>
      <ClearInNavbar data={defaultData} />
      <Meta
        title={title}
        description={description}
        canonical={canonical}
        keywords={keywords}
      />
      <ItrProductGuidePage />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(
            BLOG_POST_SCHEMA({
              title: title,
              metaDesc: description,
              keywords: keywords,
              url: canonical,
              dateModified: '2024-05-31T04:27:55+05:30',
            })
          ),
        }}
      ></script>
    </div>
  );
};

export const getStaticProps: GetStaticProps = staticPropsWrapper(
  __filename,
  () => {
    return returnNoProps();
  }
);

export default ItrProductGuide;
